

const selectors$tc = {
  stackedWrapper: ".product__wrapper--stacked",
  productSlideHidden: ".product__slide:not(.hidden)",
};

if (!customElements.get('product-gallery-manager')) {
  class ProductGalleryManager extends HTMLElement {
    constructor() {
      super();
      this._onSliderLoaded = () => {
        if (!this._variantFilterApplied) {
          this._applyInitialVariantImages();
        } else {
          this._refreshCarousel();
        }
      };
    }

    connectedCallback() {
      this.container = this.closest('[data-section-type="product"]') || this.closest('[data-section-type="api-product-upsell"]');

      this.productId = this.container.querySelector(
        'input[name="productId"]'
      ).value;

      if (this.container) {
        this.container.addEventListener('slider-loaded', this._onSliderLoaded);
      }

      this._initVariantMedia();

      this._addEventListeners();
    }

    disconnectedCallback() {
      if (this.container) {
        this.container.removeEventListener('slider-loaded', this._onSliderLoaded);
      }
    }

    _addEventListeners() {

      const optionsRadios = this.container.querySelectorAll('.product__selectors input[type="radio"]:not(.optional-product__radio)');

      optionsRadios.forEach((radio) => {
        radio.addEventListener("change", this._onVariantSelected.bind(this));
      });
    }

    _onVariantSelected(event) {
      const selected = event.target;
      if (selected.getAttribute("name") == "options[Color]") {
        const value = selected.value.toLowerCase().replaceAll(" ", "-");
        this._showVariantImages(value);
      }
    }

    _initVariantMedia() {
      let checked = this.container.querySelector(
        'input[name="options[Color]"]:checked',
      );

      if (checked) {
        checked = checked.value.toLowerCase().replaceAll(" ", "-");
      }

      this._initialColorFilter = checked;

      const groupId = this.container.querySelector(
        '.product-form input[name="productId"]'
      )?.value;

      if (!groupId) {
        return;
      }

      const slideshow = this.querySelector('[data-product-slideshow]');

      // Apply now if there is no slideshow, or Splide is already mounted.
      // Otherwise wait for `slider-loaded` (PDP and quick-add).
      if (!slideshow || slideshow.classList.contains('is-initialized')) {
        this._applyInitialVariantImages();
      }
    }

    _applyInitialVariantImages() {
      if (this._variantFilterApplied) {
        return;
      }

      this._variantFilterApplied = true;
      this._showVariantImages(this._initialColorFilter);
    }

    _filterMediaByColor(slideRoot, value, productId) {
      const slides = slideRoot.querySelectorAll(".product__slide");

      slides.forEach((slide) => {
        slide.classList.add("hidden");
        let option = slide.dataset.option;
        const groupId = slide.dataset.groupId;

        if (option) {
          option = option.toLowerCase().replaceAll(" ", "-");
          if (option.includes(value) && groupId == productId) {
            slide.classList.remove("hidden");
            slide.classList.remove("product__slide--non-critical");
          }
        }
      });
    }

    _showVariantImages(value) {
      const productId = this.productId;
      const slideRoot = this;

      if (this.container.classList.contains("product--no-color") !== true) {
        this._filterMediaByColor(slideRoot, value, productId);
      } else {
        slideRoot.querySelectorAll(".product__slide").forEach((slide) => {
          slide.classList.remove("hidden");
          slide.classList.remove("product__slide--non-critical");
        });
      }

      this._refreshCarousel();
    }

    _refreshCarousel() {
      const modal = this.closest('[data-quick-add-modal]');
      const sectionId = modal?.id || this.container?.dataset?.sectionId;
      const media =
        window.theme?.mediaInstances?.[sectionId] ||
        this.querySelector('product-media');

      if (media?.refreshSlider) {
        media.refreshSlider();
      }
    }
  }

  customElements.define('product-gallery-manager', ProductGalleryManager);
}
